import React from 'react';
import Responsive from '@amzn/meridian/responsive';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Icon from '@amzn/meridian/icon';
import arrowLeftLargeTokens from '@amzn/meridian-tokens/base/icon/arrow-left-large';
import Link from '@amzn/meridian/link';
import Box from '@amzn/meridian/box';

import { renderUrl, urls } from '../../../config/Url';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router';

import ConsolidatedContacts from '../../CoachingNotes/ConsolidatedContacts/ConsolidatedContacts';

const ContactTableFormWrapper: React.FC = (): React.ReactElement => {
  const { userId } = useParams() as { userId: string };
  const navigate = useNavigate();

  return (
    <Responsive
      query='min-width'
      props={{
        isBig: { default: false, '1330px': true },
      }}
    >
      {({ isBig }): React.ReactElement => (
        <Box>
          <Column spacingInset='median' width={isBig ? '50%' : '100%'}>
            <Row spacingInset='400'>
              <Icon tokens={arrowLeftLargeTokens} />
              <Link
                href={renderUrl(`${urls.coachingForm}/${userId}`)}
                onClick={navigate}
                type='secondary'
                data-csa-c-type='element'
                data-csa-c-slot-id='coaching-form-navigation-slot'
                data-csa-c-content-id='coaching-form-navigation-back-link'
              >
                <FormattedMessage
                  id='cs_perfportal_navigate_back'
                  defaultMessage='Back'
                  description='Link to go back'
                />
              </Link>
            </Row>
          </Column>
          <ConsolidatedContacts
            userId={userId}
            week={null}
            sourcePage={'Coaching Form'}
          />
        </Box>
      )}
    </Responsive>
  );
};

export default ContactTableFormWrapper;
